export const tabellaAllergeni = {
    'it': {
      a1: "cereali",
      a2: "crostacei",
      a3: "uova",
      a4: "pesce",
      a5: "arachidi",
      a6: "soia",
      a7: "latte",
      a8: "frutta",
      a9: "sedano",
      a10: "senape",
      a11: "semi di sesamo",
      a12: "solfiti",
      a13: "lupini",
      a14: "molluschi"
    },
  
    'en': {
      a1: "cereals",
      a2: "shellfish",
      a3: "eggs",
      a4: "fish",
      a5: "peanuts",
      a6: "soy",
      a7: "milk",
      a8: "fruit",
      a9: "celery",
      a10: "mustard",
      a11: "sesame seeds",
      a12: "solfiti",
      a13: "lupins",
      a14: "clams"
    }
  }